import { useState } from 'react'

import type { User } from '../../../services/usersManagement'
import { USER_MANAGEMENT_DEFAULTS as D } from '../UserManagement.constants'

export type UserFormData = {
    // Tab 1
    userType: string
    partnerPortalAccess: string
    cspAccess: boolean
    psaAccess: boolean
    // Tab 2
    firstName: string
    lastName: string
    func: string
    email: string
    isGAShieldUser: boolean
    // Tab 3
    selectedCustomer: string
    selectedRole: string
    selectedProducts: string[]
    isMultiTenantUser: boolean
}

const INITIAL_FORM: UserFormData = {
    userType: D.USER_TYPE_REGULAR,
    partnerPortalAccess: D.ACCESS_ROLE_NONE,
    cspAccess: false,
    psaAccess: false,
    firstName: '',
    lastName: '',
    func: '',
    email: '',
    isGAShieldUser: false,
    selectedCustomer: '',
    selectedRole: '',
    selectedProducts: [],
    isMultiTenantUser: false,
}

export type FormUpdate = <K extends keyof UserFormData>(key: K, value: UserFormData[K]) => void

export function useUserManagementForm() {
    const [formData, setFormData] = useState<UserFormData>(INITIAL_FORM)
    const [isDirty, setIsDirty] = useState(false)

    const update: FormUpdate = (key, value) => {
        setFormData(prev => ({ ...prev, [key]: value }))
        setIsDirty(true)
    }

    const reset = () => {
        setFormData(INITIAL_FORM)
        setIsDirty(false)
    }

    const prefill = (user: User) => {
        setFormData({
            userType: user.isSystemAdmin ? D.USER_TYPE_ADMIN : user.isUserManager ? D.USER_TYPE_MANAGER : D.USER_TYPE_REGULAR,
            partnerPortalAccess: user.partnerPortalAccess || D.ACCESS_ROLE_NONE,
            cspAccess: user.cspAccess ?? false,
            psaAccess: user.psaAccess ?? false,
            firstName: user.firstname || '',
            lastName: user.lastname || '',
            func: user.function || '',
            email: user.email || '',
            isGAShieldUser: user.isGAShieldUser ?? false,
            // Tab 3 fields start empty — existing assignments are loaded into the table via initialRoles
            selectedCustomer: '',
            selectedRole: '',
            selectedProducts: [],
            isMultiTenantUser: user.isMultiTenantUser ?? false,
        })
        setIsDirty(false)
    }

    return { formData, update, reset, prefill, isDirty }
}
